import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy } from "react";
// ? --------------------------  Portfolio -------------------------- ? //
const AuthLayout = lazy(() => import("./sports/ncaa-male/layouts/AuthLayout"));
const SportsLayout = lazy(
  () => import("./sports/ncaa-male/layouts/SportsLayout"),
);
const Splash = lazy(
  () => import("./sports/ncaa-male/components/Splash/Splash"),
);
const Login = lazy(() => import("./sports/ncaa-male/views/login/Login"));
const Signup = lazy(() => import("./sports/ncaa-male/views/login/SignUp"));
const Forgot = lazy(() => import("./sports/ncaa-male/views/login/Forgot"));
const AppLayout = lazy(() => import("./sports/ncaa-male/layouts/AppLayout"));
const Home = lazy(() => import("./sports/ncaa-male/views/home/Home"));
const Sports = lazy(() => import("./sports/ncaa-male/views/Sports/Sports"));
const PrivateRoute = lazy(
  () => import("./sports/ncaa-male/components/PrivateRoute/PrivateRoute"),
);
const MyPortfolio = lazy(
  () => import("./sports/ncaa-male/views/myPortfolio/MyPortfolio"),
);
const HistoryLayout = lazy(
  () => import("./sports/ncaa-male/layouts/HistoryLayout"),
);
const InstructionsLayout = lazy(
  () => import("./sports/ncaa-male/layouts/InstructionsLayout"),
);
const StatsLayout = lazy(
  () => import("./sports/ncaa-male/layouts/StatsLayout"),
);
const Stats = lazy(() => import("./sports/ncaa-male/views/Stats/Stats"));
const Instructions = lazy(
  () =>
    import("./sports/ncaa-male/views/InstructionsPortfolios/InstructionsPortfolios"),
);
const History = lazy(
  () => import("./sports/ncaa-male/views/HistoryPortfolios/HistoryPortfolios"),
);
const Error404 = lazy(
  () => import("./sports/ncaa-male/views/Error404/Error404"),
);
// fondos
import ImgStats from "@/assets/img/NCAA-STATS_Male_backup.png";
import ImgHistory from "@/assets/img/NCAA-HISTORY_Male_Back.png";
import ImgInstructions from "@/assets/img/NCAA-MALE-INSTRUCTIONS-BACK.png";
// import WIP from "./sports/ncaa-male/views/WIP/WIP";
import MyPortfolioEPL from "./sports/epl/views/myPortfolioEPL/MyPortfolioEPL";
const ImgSports =
  "https://s3.mx-central-1.amazonaws.com/portfolio.pool/sports/epl/stats/back_stats.png?quality=5&format=webp";

// ? --------------------------  EPL Imagenes -------------------------- ? //
// const NCAAFemaleImg =
//   "https://s3.mx-central-1.amazonaws.com/portfolio.pool/resources/coming_soon_rose.png?quality=80&format=webp";
// const NCAAMaleImg =
//   "https://s3.mx-central-1.amazonaws.com/portfolio.pool/resources/coming_soon_orange.png?quality=80&format=webp";

// ? --------------------------  EPL Router -------------------------- ? //
const AppLayoutEPL = lazy(() => import("./sports/epl/layouts/AppLayoutEPL"));
const StatsLayoutEpl = lazy(
  () => import("./sports/epl/layouts/StatsLayoutEpl"),
);
const HomeEPL = lazy(() => import("./sports/epl/views/HomeEPL/HomeEPL"));
const InstructionsEPL = lazy(
  () => import("./sports/epl/views/InstructionsEpl/InstructionsEpl"),
);
const StatsEpl = lazy(() => import("./sports/epl/views/StatsEpl/StatsEpl"));

// ? --------------------------  NFL Router -------------------------- ? //
const AppLayoutNFL = lazy(() => import("./sports/nfl/layouts/AppLayoutNFL"));
const StatsLayoutNfl = lazy(
  () => import("./sports/nfl/layouts/StatsLayoutNfl"),
);
const HistoryLayoutNfl = lazy(
  () => import("./sports/nfl/layouts/HistoryLayoutNfl"),
);
const HomeNFL = lazy(() => import("./sports/nfl/views/HomeNFL/HomeNFL"));
const MyPortfolioNFL = lazy(
  () => import("./sports/nfl/views/myPortfolioNFL/MyPortfolioNFL"),
);
const InstructionsNfl = lazy(
  () => import("./sports/nfl/views/InstructionsNfl/InstructionsNfl"),
);
const StatsNfl = lazy(() => import("./sports/nfl/views/StatsNfl/StatsNfl"));
const HistoryNfl = lazy(
  () => import("./sports/nfl/views/HistoryPortfolios/HistoryPortfolios"),
);

// ? --------------------------  World Cup Router -------------------------- ? //
const AppLayoutWorldCup = lazy(
  () => import("./sports/worldcup/layouts/AppLayoutWorldCup"),
);
const HistoryLayoutWorldCup = lazy(
  () => import("./sports/worldcup/layouts/HistoryLayoutWorldCup"),
);
const StatsLayoutWorldCup = lazy(
  () => import("./sports/worldcup/layouts/StatsLayoutWorldCup"),
);
const InstructionsLayoutWorldCup = lazy(
  () => import("./sports/worldcup/layouts/InstructionsLayoutWorldCup"),
);
const HomeWorldCup = lazy(
  () => import("./sports/worldcup/views/home/HomeWorldCup"),
);
const MyPortfolioWorldCup = lazy(
  () => import("./sports/worldcup/views/myPortfolio/MyPortfolioWorldCup"),
);
const StatsWorldCup = lazy(
  () => import("./sports/worldcup/views/Stats/StatsWorldCup"),
);
const HistoryWorldCup = lazy(
  () => import("./sports/worldcup/views/HistoryPortfolios/HistoryWorldCup"),
);
const InstructionsWorldCup = lazy(
  () =>
    import("./sports/worldcup/views/InstructionsPortfolios/InstructionsWorldCup"),
);

// ? --------------------------  Female Router -------------------------- ? //
const AppLayoutFemale = lazy(
  () => import("./sports/female/layouts/AppLayoutFemale"),
);
const HomeFemale = lazy(
  () => import("./sports/female/views/homeFemale/HomeFemale"),
);
const InstructionsFemale = lazy(
  () => import("./sports/female/views/InstructionsFemale/InstructionsFemale"),
);
const StatsFemale = lazy(
  () => import("./sports/female/views/StatsFemale/StatsFemale"),
);
const HistoryFemale = lazy(
  () => import("./sports/female/views/HistoryFemale/HistoryFemale"),
);
const InstructionsFemaleLayout = lazy(
  () => import("./sports/female/layouts/InstructionsFemaleLayout"),
);
const StatsFemaleLayout = lazy(
  () => import("./sports/female/layouts/StatsFemaleLayout"),
);
const HistoryFemaleLayout = lazy(
  () => import("./sports/female/layouts/HistoryFemaleLayout"),
);
const PortfolioFemale = lazy(
  () => import("./sports/female/views/PortfolioFemale/PortfolioFemale"),
);

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
          {/* Portfolio Pool Routes */}
          <Route
            path="/"
            element={<Splash />}
          />
          <Route element={<AuthLayout />}>
            <Route
              path="/login"
              element={<Login />}
            />
            <Route
              path="/signup"
              element={<Signup />}
            />
            <Route
              path="/forgot"
              element={<Forgot />}
            />
          </Route>
          <Route element={<SportsLayout ImgSports={ImgSports} />}>
            <Route
              path="/sports/:userId"
              element={<Sports />}
            />
          </Route>
          <Route element={<AppLayoutFemale />}>
            <Route
              path="/ncaa-female/home/:userId/:sportId"
              element={
                <PrivateRoute>
                  <HomeFemale />
                </PrivateRoute>
              }
            />
            <Route
              path="/ncaa-female/myPortfolio/:userId/:sportId"
              element={
                <PrivateRoute>
                  <PortfolioFemale />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<InstructionsFemaleLayout />}>
            <Route
              path="/ncaa-female/instructions/:userId/:sportId"
              element={
                <PrivateRoute>
                  <InstructionsFemale />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<StatsFemaleLayout />}>
            <Route
              path="/ncaa-female/stats/:userId/:sportId"
              element={
                <PrivateRoute>
                  <StatsFemale />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<HistoryFemaleLayout />}>
            <Route
              path="/ncaa-female/history/:userId/:sportId"
              element={
                <PrivateRoute>
                  <HistoryFemale />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<AppLayout />}>
            <Route
              path="/home/:userId"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/myPortfolio/:userId"
              element={
                <PrivateRoute>
                  <MyPortfolio />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            element={<InstructionsLayout ImgInstructions={ImgInstructions} />}
          >
            <Route
              path="/instructions/:userId"
              element={
                <PrivateRoute>
                  <Instructions />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<HistoryLayout ImgHistory={ImgHistory} />}>
            <Route
              path="/history/:userId"
              element={
                <PrivateRoute>
                  <History />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<StatsLayout ImgStats={ImgStats} />}>
            <Route
              path="/stats/:userId"
              element={
                <PrivateRoute>
                  <Stats />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<AuthLayout />}>
            <Route
              path="*"
              element={<Error404 />}
            />
          </Route>
          {/* EPL Routes */}
          <Route element={<AppLayoutEPL />}>
            <Route
              path="/epl/home/:userId/:sportId"
              element={
                <PrivateRoute>
                  <HomeEPL />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<AppLayoutEPL />}>
            <Route
              path="/epl/myPortfolio/:userId/:sportId"
              element={
                <PrivateRoute>
                  <MyPortfolioEPL />
                </PrivateRoute>
              }
            />
            {/* </Route> */}
            {/* <Route element={<AppLayoutEPL />}> */}
            <Route
              path="/epl/instructions/:userId/:sportId"
              element={
                <PrivateRoute>
                  <InstructionsEPL />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<StatsLayoutEpl />}>
            <Route
              path="/epl/stats/:userId/:sportId"
              element={
                <PrivateRoute>
                  <StatsEpl />
                </PrivateRoute>
              }
            />
          </Route>
          {/* World Cup Routes */}
          <Route element={<AppLayoutWorldCup />}>
            <Route
              path="/worldcup/home/:userId/:sportId"
              element={
                <PrivateRoute>
                  <HomeWorldCup />
                </PrivateRoute>
              }
            />
            <Route
              path="/worldcup/myPortfolio/:userId/:sportId"
              element={
                <PrivateRoute>
                  <MyPortfolioWorldCup />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<StatsLayoutWorldCup />}>
            <Route
              path="/worldcup/stats/:userId/:sportId"
              element={
                <PrivateRoute>
                  <StatsWorldCup />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<HistoryLayoutWorldCup />}>
            <Route
              path="/worldcup/history/:userId/:sportId"
              element={
                <PrivateRoute>
                  <HistoryWorldCup />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<InstructionsLayoutWorldCup />}>
            <Route
              path="/worldcup/instructions/:userId/:sportId"
              element={
                <PrivateRoute>
                  <InstructionsWorldCup />
                </PrivateRoute>
              }
            />
          </Route>
          {/* NFL Routes */}
          <Route element={<AppLayoutNFL />}>
            <Route
              path="/nfl/home/:userId/:sportId"
              element={
                <PrivateRoute>
                  <HomeNFL />
                </PrivateRoute>
              }
            />
            <Route
              path="/nfl/myPortfolio/:userId/:sportId"
              element={
                <PrivateRoute>
                  <MyPortfolioNFL />
                </PrivateRoute>
              }
            />
            <Route
              path="/nfl/instructions/:userId/:sportId"
              element={
                <PrivateRoute>
                  <InstructionsNfl />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<StatsLayoutNfl />}>
            <Route
              path="/nfl/stats/:userId/:sportId"
              element={
                <PrivateRoute>
                  <StatsNfl />
                </PrivateRoute>
              }
            />
          </Route>
          <Route element={<HistoryLayoutNfl />}>
            <Route
              path="/nfl/history/:userId/:sportId"
              element={
                <PrivateRoute>
                  <HistoryNfl />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
    </BrowserRouter>
  );
};

export default Router;
